"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TitleBlockMenuItem = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var draft_menu_1 = require("@kaizen/draft-menu");
var TitleBlockMenuItem_module_scss_1 = __importDefault(require("./TitleBlockMenuItem.module.scss"));
var TitleBlockMenuItem = function (props) {
    var className = (0, classnames_1["default"])(TitleBlockMenuItem_module_scss_1["default"].menuItem, TitleBlockMenuItem_module_scss_1["default"].destructive && TitleBlockMenuItem_module_scss_1["default"]["menuItem--destructive"], TitleBlockMenuItem_module_scss_1["default"].disabled && TitleBlockMenuItem_module_scss_1["default"]["menuItem--disabled"], TitleBlockMenuItem_module_scss_1["default"].isActive && TitleBlockMenuItem_module_scss_1["default"]["menuItem--active"]);
    if ("component" in props) {
        var CustomMenuItem = props.component, label = props.label, icon = props.icon, otherProps = __rest(props, ["component", "label", "icon"]);
        var wrappedLabel = react_1["default"].createElement("span", { className: TitleBlockMenuItem_module_scss_1["default"].menuItem__Label }, label);
        var iconNode = icon && (react_1["default"].createElement("span", { className: TitleBlockMenuItem_module_scss_1["default"].menuItem__Icon },
            react_1["default"].createElement(component_library_1.Icon, { icon: icon, role: "presentation" })));
        return (react_1["default"].createElement("li", { className: TitleBlockMenuItem_module_scss_1["default"].menuListItem },
            react_1["default"].createElement(CustomMenuItem, __assign({}, otherProps, { className: className }),
                iconNode,
                wrappedLabel)));
    }
    return react_1["default"].createElement(draft_menu_1.MenuItem, __assign({}, props));
};
exports.TitleBlockMenuItem = TitleBlockMenuItem;
//# sourceMappingURL=TitleBlockMenuItem.js.map